export const ProgramUserPermissions = {
  MayViewValidationReport: 'PG-MVVR',
  MayViewProgramLifeCycle: 'PG-MVPLC',
  MayViewProgramInfo: 'PG-MVPI',
  MayCreatePrograms: 'PG-MCP',
};

export const ProgramAdminPermissions = {
  ...ProgramUserPermissions,
  MaySelectSubCode: 'PG-MSS',
  MayCloneProgram: 'PG-MCLP',
};

export const ProgramPermissions = {
  ...ProgramAdminPermissions,
};
